import React from 'react'

import { useActionHandler } from '@/hooks/useActionHandler'

import Carousel from '../../Carousel'
import * as S from './styles'

interface CarouselBannerProps {
  items: BannerComponent[]
  style?: {
    marginTop?: string
    marginBottom?: string
    timer?: number
    infinite?: boolean
    gap?: number
    padding?: number
    width?: string
    height?: string
    borderRadius?: number
  }
}

export const CarouselBanner: React.FC<CarouselBannerProps> = ({ items, style }) => {
  const { dispatchAction } = useActionHandler()

  return (
    <S.ContainerCarouselBanner
      style={{ marginTop: style?.marginTop, marginBottom: style?.marginBottom }}
    >
      <Carousel
        gap={style?.gap ?? 0}
        padding={style?.padding ?? 16}
        infinite={style?.infinite ?? false}
        timer={style?.timer ?? 3000}
      >
        {items.map((item) => (
          <div
            key={item.id}
            style={{
              width: style?.width ?? '150px',
              height: style?.height ?? '197px',
              cursor: 'pointer',
            }}
            aria-hidden
            onClick={() => dispatchAction(item.props.action, item.props.analytics)}
          >
            <img
              src={item.props.image}
              alt={item.id}
              style={{
                width: style?.width ?? '150px',
                height: style?.height ?? '100%',
                borderRadius: style?.borderRadius ?? 8,
              }}
            />
          </div>
        ))}
      </Carousel>
    </S.ContainerCarouselBanner>
  )
}
